/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { CONTACT_TYPE_DEBTOR } from '@gh/builder-shared-data';
import { createContextRoute } from '@gh/common-internal-shared';
import {
  ContactDetailsBusinessService,
  ContactDetailsDebtorCommonTabComponent,
  ContactDetailsSharedCommunicationListTabComponent,
  ContactDetailsSharedCustomFieldsTabComponent,
  ContactDetailsSharedTermsPayerTabComponent,
} from '../../index';
import { ContactDetailsModel } from '../../services/contact-details-model.service';
import { ContactDetailsDebtorFormState } from './contact-details-debtor-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-debtor-tab',
  templateUrl: 'contact-details-debtor-tab.component.html',
})
export class ContactDetailsDebtorTabComponent {
  routes = [
    createContextRoute({
      component: ContactDetailsDebtorCommonTabComponent,
      path: 'common',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initDebtorCommonTabView',
      },
    }),

    createContextRoute({
      component: ContactDetailsSharedTermsPayerTabComponent,
      path: 'terms',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedTermsPayerTabView',
      },
      static: {
        tab: 'debtor',
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCommunicationListTabComponent,
      path: 'communications',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedCommunicationsTabView',
      },
      static: {
        tab: 'debtor',
        contactType: CONTACT_TYPE_DEBTOR,
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCustomFieldsTabComponent,
      path: 'customFields',
      static: {
        tab: 'debtor',
      },
    }),
  ];

  constructor(public model: ContactDetailsModel,
              public form: ContactDetailsDebtorFormState,
              public userContext: BuilderUserContext) {
  }

  get currentTab(): string {
    return <string>this.model.getSlaveTabFor('debtor');
  }

  onTabChanged(name: string): void {
    this.model.goToSubTab(name);
  }
}
